import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { faListAlt } from "@fortawesome/free-solid-svg-icons";
import { Counterpart } from "../../model/domain/Counterpart";
import { PagedList } from "../../model/domain/PagedList";
import { AuthService } from "../../services/auth.service";
import { Counterpartservice } from "../../services/counterpart.service";
import { Roles } from "../auth/auth.role";

@Component({
  selector: "counterpart",
  templateUrl: "./counterpart-list.component.html",
  styleUrls: ["./counterpart-list.component.css"],
})
export class CounterpartListComponent implements OnInit {
  faListAlt = faListAlt;

  displayedColumns = [
    "actions",
    "name",
    "document",
    "selicAccount",
    "cetipAccount",
    "brokerAccount",
    "b3Account",
  ];
  model: Counterpart[] = null;

  name: string = null;
  document: string = null;
  currentPage: number = 1;
  totalPages: number = null;
  totalItems: number = null;
  listedPages: any[];
  firstItemOnPage: number;
  lastItemOnPage: number;

  constructor(
    private service: Counterpartservice,
    private router: Router,
    private authService: AuthService
  ) {}

  ngOnInit() {
    this.getCounterpart();
  }

  getCounterpart(page: number = null, pageSize: number = null) {
    if (!page) {
      page = 1;
    }

    if (!pageSize) {
      pageSize = 10;
    }

    this.service
      .GetCounterparts(this.name, this.document, page, pageSize)
      .subscribe((q) => {
        this.model = q.results;
        this.renderPaginador(q, page);
      });
  }

  clearFilters() {
    this.service.GetCounterparts(null, null, 1, 10).subscribe((q) => {
      this.model = q.results;
      this.renderPaginador(q, 1);
    });

    this.name = null;
    this.document = null;
  }

  renderPaginador(result: PagedList<Counterpart>, page: number) {
    this.totalItems = result.rowCount;
    this.totalPages = result.pageCount;
    this.firstItemOnPage = result.firstRowOnPage;
    this.lastItemOnPage = result.lastRowOnPage;

    this.currentPage = page;

    this.listedPages = [];

    let startPage = this.currentPage - 2;

    if (startPage <= 0) {
      startPage = 1;
    }

    let maxPage = this.currentPage + 2;

    while (maxPage > this.totalPages) {
      maxPage--;
    }

    for (let i = startPage; i <= maxPage; i++) {
      this.listedPages.push(i);
    }

    if (!result.results.length) {
      this.totalPages = 1;
      this.currentPage = 1;
      this.firstItemOnPage = 0;

      this.listedPages = [];
      this.listedPages.push(1);
    }
  }

  openCounterpart(id: number = null) {
    if (id === null) {
      this.router.navigate(["/cadastro-contraparte"]);
    } else {
      this.router.navigate(["/cadastro-contraparte", id]);
    }
  }

  canCreateCounterpart() {
    const roles = [Roles.CreateCounterpart];
    return this.authService.hasRoles(roles);
  }
}
